import React from "react";
import RadioOption from "./RadioOption";

const RadioButtons = ({ options, value, onChange = () => {} }) => {
  return (
    <>
      {options.map((option) => (
        <RadioOption key={option.value} option={option} isSelected={value === option.value} onChange={onChange} />
      ))}
    </>
  );
};

export default RadioButtons;
